import _ from 'lodash'
import toastr from 'toastr'
import layout from 'layouts/default'
import { hasPermits } from 'directives'
import { permits, twoFactorPolicy, user as userService } from 'services'

const directives = {
  hasPermits
}

const components = {
  layout
}

const computed = {
  twoFactorActions () {
    return twoFactorPolicy.actions
  },
  canEditTwoFactorAction () {
    const currentUser = userService.getUser()
    return !!(
      currentUser &&
      currentUser.type === 'ims' &&
      permits.hasPermit('user_update')
    )
  },
  rolesChanged () {
    return !_.isEqual(this.roleIds(this.form.roles), this.initialRoleIds)
  },
  roles () {
    return this.$store.state.roles.all;
  },
  countries () {
    let countries = [{name: "Select Country", id: null}]
      .concat(this.$store.state.address.countries)

    return countries
  },
  states () {
    let states = [{name: "Select State", id: null}];
    if (this.form.country_id) {

      let indx = _.findIndex(this.countries, item => item.id == this.form.country_id);
      if (indx > -1) {
        states = states.concat(this.countries[indx].states);
      }
    }

    return states;
  }
}

const methods = {
  twoFactorActionLabel (value) {
    return twoFactorPolicy.label(value)
  },

  roleIds (roles) {
    return _.map(roles || [], role => {
      return role && typeof role === 'object' ? role.id : role
    }).filter(role => role !== '' && role !== null && role !== undefined)
  },

  setForm (source) {
    this.form = _.cloneDeep(source)
    this.form.two_fa_action = twoFactorPolicy.normalize(this.form.two_fa_action)
    this.initialRoleIds = this.roleIds(this.form.roles)
    if (this.form.roles) {
      if (!this.form.roles.length) {
        this.form.roles.push('')
      } else {
        this.form.roles = this.initialRoleIds.length ? [this.initialRoleIds[0]] : ['']
      }
    }
  },

  submit () {
    this.errors = {}
    if (this.form.password) {
      if (this.form.password !== this.form.password_confirmation) {
        this.errors.password = ['Password and password confirmation do not match']
        return;
      }
    }

    let data = _.cloneDeep(this.form);
    const rolesChanged = this.rolesChanged

    try {
      if (data.roles[0] == '') {
        delete data.roles;
      }
    } catch(e) {}

    if (rolesChanged) {
      delete data.two_fa_action
    } else {
      delete data.roles
      if (!this.canEditTwoFactorAction) {
        delete data.two_fa_action
      }
    }

    this.processing = true;
    this.$store.dispatch('users.editUser', {id: this.$route.params.id, data})
    .then(() => {
      if (rolesChanged && !this.$store.state.users.errors) {
        return this.$store.dispatch('users.getUser', this.$route.params.id)
      }
    })
    .then(() => {
      this.processing = false;
      let errors = this.$store.state.users.errors;
      if (errors) {
        if (errors.errors) {
          this.errors = _.cloneDeep(errors.errors);
        }
        toastr.error(errors.message);
      } else {
        if (rolesChanged) {
          this.setForm(this.$store.state.users.active)
        }
        toastr.success('Data has been saved');
      }
    });
  }
}

export default {
  name: 'edit-user',
  components,
  computed,
  methods,
  directives,
  data () {
    return {
      loading: true,
      processing: false,
      errors: {},
      form: {
        country_id: null,
        state_id: null,
        prevent_frontend_access: false
      },
      initialRoleIds: []
    }
  },
  created () {
    this.$store.dispatch('users.getUser', this.$route.params.id).then(() => {
      this.loading = false;
      this.setForm(this.$store.state.users.active);
      console.log('form', this.form);
    });
    this.$store.dispatch('address.getCountries');
  }
}
